new Vue({
    delimiters: ['[[', ']]'], // change because vue and django using the same args 
    el: '#app_home',
    data: {
        banners: {
            bandCommuniqueDropdown: false,
        },
        mobile: (window.innerWidth > 991) ? false : true,
        tabletPortrait: (window.innerWidth > 767) ? true : false,

        newsletterName: '',
        newsletterMail: '',
    },
    created() {
        window.addEventListener("resize", this.screenHandler);
    },
    mounted() {
        this.secondBlock = true;
    },
    destroyed() {
        window.removeEventListener("resize", this.screenHandler);
    },
    computed: {
        newsletterOn() {
            return this.newsletterName > '' && this.newsletterMail > '';
        }
    },
    methods: {
        screenHandler() {
            this.mobile = (window.innerWidth > 991) ? false : true;
            this.tabletPortrait = (window.innerWidth > 767) ? true : false;
        }
    }
})

//sliders
$(document).ready(function () {
    var bannerHomeFull = $('.home__banner');

    var optionsBannerHome = {
        arrows: true,
        autoplay: true,
        autoplaySpeed: 8000,
        dots: false,
        //fade: true,
        infinite: true,
        mobileFirst: true,
        adaptiveHeight: true,
        pauseOnHover: true,
        pauseOnFocus: true,
        slidesToShow: 1,
        speed: 1500,
        cssEase: 'cubic-bezier(0.39, 0.58, 0.15, 0.98)',
    }

    // Init banner
    function initBannerHome(el) {
        el.slick(optionsBannerHome);
    }

    bannerHomeFull.on('init', function(event, slick) {
        $('.banner-home').find('.banner-home__loading').hide();
        $('.slider-slick').css({
            visibility: 'visible',
            opacity: '1'
        });
    });

    initBannerHome(bannerHomeFull);

    $('.banner_communique').slick({
        arrows: false,
        dots: false,
        infinite: false,
        mobileFirst: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        delay: 2000,
        speed: 700,

        responsive: [
            {
                breakpoint: 767,
                settings: {
                    autoplay: false,
                    slidesToShow: 3,
                }
            },
            {
                breakpoint: 991,
                settings: {
                    arrows: true,
                    autoplay: false,
                    slidesToShow: 4,
                }
            }
        ]
    })

    $('.product_list').slick({
        arrows: true,
        dots: false,
        infinite: false,
        mobileFirst: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        speed: 700,

        responsive: [
            {
                breakpoint: 577,
                settings: {
                    slidesToShow: 3,
                }
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 3,
                }
            },
            {
                breakpoint: 991,
                settings: {
                    arrows: true,
                    slidesToShow: 4,
                }
            }
        ]
    });

    $('.product-ratings__list').slick({
        arrows: false,
        dots: true,
        infinite: false,
        autoplay: true,
        mobileFirst: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        speed: 700,

        responsive: [
            {
                breakpoint: 577,
                settings: {
                    slidesToShow: 2,
                }
            },
            {
                breakpoint: 991,
                settings: {
                    arrows: true,
                    dots: false,
                    slidesToShow: 3,
                }
            }
        ]
    });

    $('.widget-instagram__photos').slick({
        arrows: false,
        dots: false,
        infinite: false,
        autoplay: false,
        mobileFirst: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        speed: 700,

        responsive: [
            {
                breakpoint: 577,
                settings: {
                    slidesToShow: 2,
                }
            },
            {
                breakpoint: 991,
                settings: {
                    arrows: true,
                    dots: false,
                    slidesToShow: 5,
                }
            }
        ]
    });
})